export default __webpack_public_path__ + "static/media/SignPainter.b7e06888.otf";